var _desc, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit1467(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "currentColor",
    d: "M58.4 18.77l.941-.941c3.637-3.638 2.7-8.595-.941-12.233s-8.6-4.58-12.234-.94l-.941.941",
    "data-name": "layer2",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.639 24.535l5.766-5.765L45.229 5.596l-5.764 5.764",
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "currentColor",
    "data-name": "layer1",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.582 57.59l33.057-33.055L39.465 11.36 6.409 44.416 2.352 61.649l17.23-4.059zM6.409 44.416L19.582 57.59",
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    stroke: "currentColor",
    fill: "none",
    "data-name": "layer1",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1467);
export default __webpack_public_path__ + "static/media/edit-1467.89acc415671673cc67ddbbc8e3c411ca.svg";
export { ForwardRef as ReactComponent };